import { useState } from "react";
import { ImageOff } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const PageHeader = ({ overline, title, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {overline && <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#C5A059] mb-2">{overline}</div>}
      <h1 className="font-serif text-4xl sm:text-5xl text-[#121212] tracking-tight">{title}</h1>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ className = "", children, ...rest }) => (
  <div className={`rounded-2xl border border-[#E8E1D7] bg-white shadow-[0_10px_30px_-10px_rgba(18,18,18,0.06)] ${className}`} {...rest}>{children}</div>
);

export const GoldButton = ({ className = "", children, ...rest }) => (
  <button className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#121212] px-5 py-2.5 text-sm font-medium text-[#F6F1EA] border border-[#C5A059] shadow-[0_0_15px_rgba(197,160,89,0.18)] transition-[background-color,transform] duration-200 hover:bg-[#24211E] active:scale-[0.98] disabled:opacity-50 ${className}`} {...rest}>{children}</button>
);

export const GhostButton = ({ className = "", children, ...rest }) => (
  <button className={`inline-flex items-center justify-center gap-2 rounded-full border border-[#E8E1D7] bg-white px-4 py-2 text-sm text-[#24211E] transition-colors duration-200 hover:border-[#C5A059] hover:bg-[#F6F1EA] disabled:opacity-50 ${className}`} {...rest}>{children}</button>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs uppercase tracking-[0.14em] text-[#6E675F]">{label}</span>
    {children}
  </label>
);

export const inputCls = "w-full rounded-xl border border-[#E8E1D7] bg-[#FDFBF7] px-3 py-2.5 text-sm text-[#24211E] outline-none transition-colors focus:border-[#C5A059] focus:bg-white";

export const Select = ({ options, placeholder, className = "", ...rest }) => (
  <select className={`${inputCls} ${className}`} {...rest}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);

export const ProductImage = ({ path, className = "" }) => {
  const [err, setErr] = useState(false);
  if (!path || err) {
    return <div className={`flex items-center justify-center bg-[#F6F1EA] text-[#C5A059] ${className}`}><ImageOff className="h-6 w-6" strokeWidth={1.2} /></div>;
  }
  return <img src={fileUrl(path)} alt="" onError={() => setErr(true)} className={`object-cover ${className}`} />;
};

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-[#E8E1D7] bg-[#FDFBF7] px-6 py-10 text-center text-sm text-[#9E958A]">{children}</div>
);

export const StatusBadge = ({ status }) => {
  const map = {
    effettuato: "bg-[#2D6A4F]/10 text-[#2D6A4F] border-[#2D6A4F]/20",
    da_effettuare: "bg-[#C5A059]/12 text-[#8A6A22] border-[#C5A059]/40",
    programmato: "bg-[#4A6B82]/10 text-[#4A6B82] border-[#4A6B82]/20",
    completato: "bg-[#2D6A4F]/10 text-[#2D6A4F] border-[#2D6A4F]/20",
    annullato: "bg-red-50 text-red-700 border-red-200",
  };
  const label = { effettuato: "Effettuato", da_effettuare: "Da effettuare", programmato: "Programmato", completato: "Completato", annullato: "Annullato" };
  return <span className={`inline-block rounded-full border px-2.5 py-0.5 text-xs ${map[status] || ""}`}>{label[status] || status}</span>;
};
